<ion-header class="modal-header">
  <ion-toolbar>
    <div class="modal-title">
      <h3>
        Set Channels for {{ articles.length }} Article{{
          articles.length > 1 ? "s" : ""
        }}
      </h3>
    </div>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        shape="round"
        class="close-button"
        (click)="dismissModal()"
      >
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p class="info-text">
    Select the channels that <strong>all</strong> selected articles should
    belong to. Existing channel memberships will be overwritten.
  </p>

  <div class="channels-container">
    <ion-chip
      *ngFor="let channel of selectedChannelsArray; trackBy: trackByChannelId"
      mode="ios"
      color="dark"
      class="chip tag-chip"
    >
      <ion-label (click)="removeChannel(channel.id)">{{
        channel.name
      }}</ion-label>
    </ion-chip>

    <ion-chip
      *ngIf="selectedChannelsMap.size === 0"
      color="success"
      class="chip public-chip"
      mode="ios"
    >
      <ion-label>Public</ion-label>
    </ion-chip>

    <ion-chip
      mode="ios"
      color="dark"
      class="chip add-chip"
      (click)="addChannel($event)"
      button
    >
      <ion-label>
        <ion-icon name="lock-closed-outline"></ion-icon>
        <ion-icon name="add-outline" style="margin-left: -3px"></ion-icon>
      </ion-label>
    </ion-chip>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between">
  <ion-button (click)="applyChanges()" color="primary" fill="solid"
    >Save</ion-button
  >
  <ion-button (click)="dismissModal()" fill="clear" color="dark"
    >Cancel</ion-button
  >
</ion-footer>
